// 
import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appEnterKey]'
})
export class EnterKeyDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      const inputs = document.querySelectorAll('input[type="text"]');
      const index = Array.from(inputs).indexOf(this.el.nativeElement);
      const nextIndex = index + 1;
      if (nextIndex < inputs.length) {
        (inputs[nextIndex] as HTMLInputElement).focus();
        console.log('Accepted value:', this.el.nativeElement.value);
      }
    }
  }
}
